import { render } from "./Body.vue?vue&type=template&id=1f3ebd6b&scoped=true"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"

import "./Body.vue?vue&type=style&index=0&id=1f3ebd6b&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3ebd6b"]])

export default __exports__